import React, { useState } from 'react';
import { navSections } from './navData';
import './Layout.css';

const LOGO_SRC = `${process.env.PUBLIC_URL || ''}/bcrv-logo.png`;
const LOGO_ALT = 'Blue Compass RV';

function IconMenu(props) {
  return (
    <svg className={props.className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5" />
    </svg>
  );
}

function IconClose(props) {
  return (
    <svg className={props.className} fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" aria-hidden="true" {...props}>
      <path strokeLinecap="round" strokeLinejoin="round" d="M6 18L18 6M6 6l12 12" />
    </svg>
  );
}

function IconChevronDown(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className={props.className} {...props}>
      <path fillRule="evenodd" d="M5.22 8.22a.75.75 0 0 1 1.06 0L10 11.94l3.72-3.72a.75.75 0 1 1 1.06 1.06l-4.25 4.25a.75.75 0 0 1-1.06 0L5.22 9.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
    </svg>
  );
}

function IconChevronRight(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" className={props.className} {...props}>
      <path fillRule="evenodd" d="M8.22 5.22a.75.75 0 0 1 1.06 0l4.25 4.25a.75.75 0 0 1 0 1.06l-4.25 4.25a.75.75 0 0 1-1.06-1.06L11.94 10 8.22 6.28a.75.75 0 0 1 0-1.06Z" clipRule="evenodd" />
    </svg>
  );
}

export default function SiteHeader() {
  const [openMenu, setOpenMenu] = useState(null);
  const [mobileMenu, setMobileMenu] = useState(false);
  const [mobileTabs, setMobileTabs] = useState({});

  const toggleMobileTab = (id) => {
    setMobileTabs((prev) => ({ ...prev, [id]: !prev[id] }));
  };

  return (
    <header className="site-header" role="banner">
      <nav className="nav-inner" aria-label="Global">
        <div className="logo-wrap">
          <a href="https://www.bluecompassrv.com" className="logo-link">
            <span className="sr-only">Blue Compass RV</span>
            <img className="logo-img" src={LOGO_SRC} alt={LOGO_ALT} />
          </a>
        </div>

        {/* Desktop nav */}
        <div className="nav-desktop">
          {navSections.map((section) => (
            <div
              key={section.id}
              className={`nav-item-wrap ${section.lgOnly ? 'nav-item-lg-only' : ''}`}
              role="menu"
              tabIndex={-1}
              onMouseLeave={() => setOpenMenu(null)}
            >
              <div
                className="nav-item-trigger"
                role="menuitem"
                tabIndex={-1}
                onMouseOver={() => setOpenMenu(section.id)}
                onClick={() => setOpenMenu(openMenu === section.id ? null : section.id)}
              >
                {section.label}
              </div>
              {openMenu === section.id && (
                <div className={`nav-dropdown ${section.dropdownRight ? 'nav-dropdown-right' : ''}`}>
                  {section.links.map((link) => (
                    <a key={link.href + link.label} href={link.href} rel="noopener noreferrer" target="_blank" role="menuitem" tabIndex={-1}>
                      {link.label}
                    </a>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Mobile menu button */}
        <div className="nav-mobile-btn-wrap">
          <button type="button" className="nav-mobile-btn" onClick={() => setMobileMenu(true)} aria-label="Open main menu">
            <span className="sr-only">Open main menu</span>
            <IconMenu />
          </button>
        </div>
      </nav>

      {/* Mobile menu */}
      {mobileMenu && (
        <div className="mobile-menu-wrap" role="dialog" aria-modal="true">
          <div className="mobile-menu-backdrop" onClick={() => setMobileMenu(false)} onKeyDown={(e) => e.key === 'Escape' && setMobileMenu(false)} role="presentation" />
          <div className="mobile-menu-panel">
            <div className="mobile-menu-header">
              <a href="https://www.bluecompassrv.com" onClick={() => setMobileMenu(false)}>
                <span className="sr-only">BCRV</span>
                <img className="logo-img" style={{ height: '2rem' }} src={LOGO_SRC} alt={LOGO_ALT} />
              </a>
              <button type="button" className="mobile-menu-close" onClick={() => setMobileMenu(false)} aria-label="Close menu">
                <span className="sr-only">Close menu</span>
                <IconClose />
              </button>
            </div>
            <div className="mobile-menu-nav">
              {navSections.map((section) => (
                <div key={section.id} className="mobile-menu-section">
                  <button
                    type="button"
                    className="mobile-menu-trigger"
                    onClick={() => toggleMobileTab(section.id)}
                    aria-expanded={!!mobileTabs[section.id]}
                  >
                    {section.label}
                    <span className="chevron">
                      {mobileTabs[section.id] ? <IconChevronDown /> : <IconChevronRight />}
                    </span>
                  </button>
                  {mobileTabs[section.id] && (
                    <div className="mobile-menu-links">
                      {section.links.map((link) => (
                        <a key={link.href + link.label} href={link.href} rel="noopener noreferrer" target="_blank" onClick={() => setMobileMenu(false)}>
                          {link.label}
                        </a>
                      ))}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
